import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { LoadModal } from "../../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import Truncate from "react-truncate"
class TableAtaReuniaoTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreAtaReuniao(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  render() {
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar ata de reunião"
        >
          {this.props.rows.map((row, key) => {
            return (
              <div key={key} className="col-md-4">
                <div className="card">
                  <div
                    className="card-header"
                    data-background-color={this.props.backgroundColor}
                  >
                    <h4 className="title text-center col-md-offset-right-1">
                      {"Contrato Nº " + row.contrato.num_contrato}
                    </h4>
                    <p className="category text-center col-md-offset-right-1">
                      {"Criada em " + Moment(row.created_at).format("D/MM/Y")}
                    </p>
                  </div>
                  <div className="ata-quote col-md-12">
                    <Truncate
                      lines={11}
                      ellipsis={<span className="label-quote">...</span>}
                    >
                      {row.ata}
                    </Truncate>
                  </div>
                  <div className="row">
                    <button
                      type="button"
                      rel="tooltip"
                      title="Restaurar ata de reunião"
                      onClick={() => this.restore(row.id)}
                      className="col-md-12 btn btn-danger btn-simple btn-xs"
                    >
                      <i className="material-icons">restore</i>
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableAtaReuniaoTrash)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/ata-reuniao/TableAtaReuniaoTrash.js